<template>
    <BCard v-if="product">
      <BRow>
          <BCol cols="12" xl="6">
              <table class="mt-2 mt-xl-0 w-100">
                  <ViewData vsIcon="UserIcon" vsLabel="Code" :vsValue="product.code" />
                  <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="product.name" />
                  <ViewData vsIcon="ShieldIcon" vsLabel="Family" :vsValue="product.family.name" />
                  <ViewData vsIcon="ShieldIcon" vsLabel="Group" :vsValue="product.group ? product.group.name : ''" />
              </table>
          </BCol>
          <BCol cols="12" xl="6">
              <table class="mt-2 mt-xl-0 w-100">
                  <ViewData vsIcon="MailIcon" vsLabel="Tax" :vsValue="product.tax.name" />
                  <ViewData vsIcon="BriefcaseIcon" vsLabel="Amount" :vsValue="product.amount" />
                  <ViewData vsIcon="UserIcon" vsLabel="Stock" :vsValue="product.stock" />
              </table>
          </BCol>
          <BCol cols="12" class="mt-2">
              <div class="d-flex flex-wrap">
                  <BButton :to="{ name: 'products-edit', params: { id: product.id } }" variant="primary" v-if="ability.can('write', 'product')"> {{$t('Edit')}} </BButton>
                  <BButton variant="outline-danger" class="ml-1" @click="deletePopup(product.id, 'products/deleteProduct', 'products')" v-if="ability.can('delete', 'product')"> {{$t('Delete')}} </BButton>
              </div>
          </BCol>
      </BRow>
    </BCard>
  </template>

<script>
import { BAlert, BRow, BCard, BCol, BButton, BLink } from 'bootstrap-vue'
import { onUnmounted, ref } from '@vue/composition-api'
import productModule from '../productModule'
import ViewData from '@/components/ViewData.vue'
import ability from '@/libs/acl/ability'
import popups from '@/hooks/popups'
import router from '@/router'
import store from '@/store'

  export default {
      components: { BAlert, BRow, BCol, BCard, BButton, BLink, ViewData },
      setup(){
        const { deletePopup } = popups();
        const PRODUCTS_MODULE = 'products'
        const product = ref(null)

        if (!store.hasModule(PRODUCTS_MODULE)) store.registerModule(PRODUCTS_MODULE, productModule)

        onUnmounted(() => {
            if(store.hasModule(PRODUCTS_MODULE)) store.unregisterModule(PRODUCTS_MODULE)
        })

        store.dispatch('products/fetchProduct', { id: router.currentRoute.params.id }).then(response => {
            product.value = response.data.product
        })


        return {
            deletePopup,
            ability,
            product,
        }
    }
  }
  </script>

  <style lang="scss">
  @import 'src/assets/scss/variables/_variables.scss';
  table tr th, .title {
    color: $primary;
  }

  table tr th span, .title {
    text-transform: uppercase;
  }
  </style>
